// AI-CONTEXT: See docs/features/participation-ladder.md
// Allowed values (enums) for participation profiles, taken from the dropdowns
// of the "Output Participatieladder" sheet (Meetstandaard Social Impact v1.0),
// plus the derived ladder labels.

// "Wat doe je op dit moment?"
export const MAIN_ACTIVITY_OPTIONS = [
    'Opleiding',
    'Werk',
    'Vrijwilligerswerk',
    'Dagbesteding',
    'Werkzoekend',
    'Niet actief',
]

// "Indien werk; hoeveel uur per week"
export const HOURS_BAND_OPTIONS = [
    'minder dan 12 uur per week',
    '12 tot 20 uur per week',
    '20 tot 35 uur per week',
    'Voltijd',
]

// "Indien werk; ben je volledig inzetbaar?" (1 = 100% inzetbaar)
export const EMPLOYABILITY_OPTIONS = [1, 0.7, 0.5, 0.3, 0.1]

// "Indien werk/opleiding; wat is je hoogst afgeronde opleiding?"
export const EDUCATION_LEVEL_OPTIONS = ['Geen startkwalificatie', 'MBO 2-4/havovwo', 'HBO/WO']

// "Indien vrijwilligerswerk; hoeveel uur per week?"
export const VOLUNTEER_HOURS_OPTIONS = [0, 4, 12, 20, 32]

// "Ontvang je een uitkering?"
export const BENEFIT_TYPE_OPTIONS = ['Geen', 'Bijstandsuitkering', 'WAO/WIA/WAZ/WAJONG']

// "Indien bijstand; welk deel van de volledige bijstand ontvang je?" (1 = volledig).
// Meetstandaard-parameters 2026.2, options.benefitShare.
export const BENEFIT_SHARE_OPTIONS = [1, 0.75, 0.5, 0.25]

// The single activity that produces paid income / tax.
export const PAID_WORK_ACTIVITY = 'Werk'

// Participatieladder treden (the 6-point Participatieladder).
export const LADDER_LABELS = {
    1: 'Geïsoleerd',
    2: 'Sociale contacten buitenshuis',
    3: 'Deelname georganiseerde activiteiten',
    4: 'Onbetaald werk',
    5: 'Betaald werk met ondersteuning',
    6: 'Betaald werk zonder ondersteuning',
}

// Sub-question shown only for the "Niet actief" activity — it distinguishes the
// bottom three rungs, which the activity alone cannot. "Indien niet actief; hoe
// ziet je situatie eruit?"
export const INACTIVITY_LEVEL_OPTIONS = [
    'Geïsoleerd',
    'Sociale contacten buitenshuis',
    'Deelname georganiseerde activiteiten',
]

// Maps the sub-question answer to its participatieladder trede (1-3).
export const INACTIVITY_LEVEL_STEPS = {
    'Geïsoleerd': 1,
    'Sociale contacten buitenshuis': 2,
    'Deelname georganiseerde activiteiten': 3,
}
